import { Radio } from "antd";
import styled from "styled-components";

export const StyledUMControlsWrapper = styled.div`
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledUMSearchWrapper = styled.div`
    width: 100%;

    .ant-input-wrapper {
        height: 44px;
    }

    .ant-input-affix-wrapper {
        height: 100%;
    }

    .ant-input::placeholder {
        color: ${(props) => props.theme.shelfValueColor};
    }
    .ant-select-selection-placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }

    input {
        font-weight: 400;
        font-size: 14px;
        line-height: 120%;
    }

    .ant-input-group-addon {
        background-color: ${(props) => props.theme.collapseHeaderBackground};

        svg {
            fill: ${(props) => props.theme.secondaryBorderColor} !important;
        }
    }
`;

export const StyledUMMarketList = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    width: 100%;
`;

export const StyledUMMarketCard = styled.div<{
    hasDuty?: boolean;
    isDisabled?: boolean;
    isSelected?: boolean;
}>`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 16px 8px;
    gap: 8px;
    border-left: 5px solid
        ${({ hasDuty, isDisabled, isSelected, theme }) =>
            isDisabled
                ? theme.disabledTypographyColor
                : isSelected
                  ? theme.colors.green
                  : hasDuty
                    ? "#FF4D4F"
                    : "transparent"};
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
    background-color: ${({ isSelected, isDisabled, theme }) =>
        isDisabled
            ? theme.secondaryBackgroundColor
            : isSelected
              ? theme.itemBackground
              : "transparent"};
    transition: all 0.2s ease;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

    ${({ isSelected, theme }) =>
        isSelected &&
        `
        border-right: 3px solid ${theme.colors.green};
        box-shadow: inset 0 0 0 1px ${theme.colors.green};
    `}
`;

export const StyledUMMarketInfo = styled.div<{ isDisabled: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    article {
        ${({ isDisabled, theme }) =>
            isDisabled && `color: ${theme.disabledTypographyColor} !important`};
    }
`;

export const StyledUMSelectionBadge = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.green};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.colors.white};
    font-size: 16px;
    box-shadow: 0 2px 8px rgba(73, 170, 25, 0.3);
    z-index: 1;

    svg {
        fill: ${(props) => props.theme.colors.white};
    }
`;

export const StyledUMRadioGroup = styled(Radio.Group)`
    display: flex;
    justify-content: center;
    margin-bottom: 16px;

    .ant-radio-button-wrapper {
        padding-inline: 10px;
    }
`;

export const StyledUMEmptyMarketGif = styled.img`
    margin-top: 20px;
    margin-bottom: 20px;
    width: 80%;
`;
